/* eslint-disable import/no-unresolved */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Taxes } from '@/components/Invoices/InvoiceItem';

export type PaymentMethod = {
  type: string;
  amount: number;
};

type DispensePoint = {
  dispense_point: string;
  name: string;
};

interface OrderType {
  restaurant_table: string;
  customer: string;
  customer_balance: number;
  paid_amount: number;
  is_occupied: boolean;
  current_invoice: string;
  cartState: 'view' | 'edit';
  timeCreated: string;
  taxes: Taxes[];
  discount: number;
  change: number;
  changeGiven: number;
  changeSaved: number;
  paymentMethod: Array<PaymentMethod>;
  sub_total: number;
  total: number;
  service_charge: boolean;
  dispense_pump: DispensePoint[];
  selected_pump: string;
  toggle_dispense_pump: boolean;
}

const OrderState: OrderType = {
  restaurant_table: '',
  customer: '',
  customer_balance: 0,
  is_occupied: false,
  current_invoice: '',
  cartState: 'edit',
  timeCreated: '',
  taxes: [],
  discount: 0,
  change: 0,
  changeGiven: 0,
  changeSaved: 0,
  paid_amount: 0,
  paymentMethod: [],
  sub_total: 0,
  total: 0,
  service_charge: false,
  dispense_pump: [],
  selected_pump: '',
  toggle_dispense_pump: false,
};

const orderSlice = createSlice({
  name: 'order',
  initialState: OrderState,
  reducers: {
    addTable: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.restaurant_table = payload;
    },
    addCustomer: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.customer = payload;
    },
    addCustomerBalance: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.customer_balance = payload;
    },
    toogleOccupied: (state: OrderType, { payload }: PayloadAction<boolean>) => {
      state.is_occupied = payload;
    },
    toogleServiceCharge: (
      state: OrderType,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.service_charge = payload;
    },
    updateInvoice: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.current_invoice = payload;
    },
    updateCartState: (
      state: OrderType,
      { payload }: PayloadAction<'view' | 'edit'>,
    ) => {
      state.cartState = payload;
    },
    updateTax: (state: OrderType, { payload }: PayloadAction<Taxes[]>) => {
      state.taxes = payload;
    },
    updateDiscount: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.discount = payload;
    },

    addTime: (state: OrderType, { payload }: PayloadAction<string>) => {
      state.timeCreated = payload;
    },
    updateChange: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.change = payload;
    },
    updateChangeGiven: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.changeGiven = payload;
    },
    updateChangeSaved: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.changeSaved = payload;
    },
    updatePaidAmount: (
      state: OrderType,
      { payload }: PayloadAction<number>,
    ) => {
      state.paid_amount = payload;
    },
    updateSubTotal: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.sub_total = payload;
    },
    updateTotal: (state: OrderType, { payload }: PayloadAction<number>) => {
      state.total = payload;
    },
    updatePaymentMethod: (
      state: OrderType,
      { payload }: PayloadAction<Array<PaymentMethod>>,
    ) => {
      state.paymentMethod = payload;
    },
    updateDispensePumps: (
      state: OrderType,
      { payload }: PayloadAction<Array<DispensePoint>>,
    ) => {
      state.dispense_pump = payload;
    },
    updateSelectedPump: (
      state: OrderType,
      { payload }: PayloadAction<string>,
    ) => {
      state.selected_pump = payload;
    },
    toggleDispensePump: (
      state: OrderType,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.toggle_dispense_pump = payload;
    },
  },
});

export const {
  addCustomer,
  addCustomerBalance,
  addTable,
  toogleOccupied,
  toogleServiceCharge,
  updateInvoice,
  updateCartState,
  addTime,
  updateTax,
  updateDiscount,
  updateChange,
  updateChangeGiven,
  updateChangeSaved,
  updatePaymentMethod,
  updatePaidAmount,
  updateSubTotal,
  updateTotal,
  updateDispensePumps,
  updateSelectedPump,
  toggleDispensePump,
} = orderSlice.actions;

export default orderSlice.reducer;
